// import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
// import { jobServices } from '../services/job.service';





// export const useUpdateJob = () => {
//   const queryClient = useQueryClient();
//   return useMutation({
//     mutationFn: ({ jobId, data }) => jobServices.updateJob({ jobId, data }),
//     onSuccess: () => {
//       queryClient.invalidateQueries({ queryKey: ['jobs'] });
//       queryClient.invalidateQueries({ queryKey: ['job-stats'] });
//     },
//   });
// };


// export const useJobs = (filters) => {
//   return useQuery({
//     queryKey: ['jobs', filters],
//     queryFn: () => jobServices.getJobs(filters),
//     staleTime: 5 * 60 * 1000, // 5 minutes
//     gcTime: 10 * 60 * 1000, // 10 minutes
//     keepPreviousData: true,
//   });
// };

// export const useJob = (jobId) => {
//   return useQuery({
//     queryKey: ['jobs', jobId],
//     queryFn: () => jobServices.getJobById(jobId),
//     enabled: !!jobId,
//     staleTime: 5 * 60 * 1000,
//   });
// };

// export const useJobStats = () => {
//   return useQuery({
//     queryKey: ['job-stats'],
//     queryFn: () => jobServices.getJobStats(),
//     staleTime: 2 * 60 * 1000, // 2 minutes
//   });
// };


import {
  useQuery,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';

import { jobServices } from '../services/job.service';

/**
 * Reusable API error parser
 */
const parseApiError = (error) => {
  return {
    message:
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      'Something went wrong',

    status: error?.response?.status || 500,

    errors: error?.response?.data?.errors || [],
  };
};

/**
 * Update job
 */
export const useUpdateJob = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ jobId, data }) => {
      try {
        return await jobServices.updateJob({
          jobId,
          data,
        });
      } catch (error) {
        throw parseApiError(error);
      }
    },

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['jobs'],
      });

      queryClient.invalidateQueries({
        queryKey: ['job-stats'],
      });
    },

    retry: 1,
  });
};

/**
 * Get all jobs
 */
export const useJobs = (filters) => {
  return useQuery({
    queryKey: ['jobs', filters],

    queryFn: async () => {
      try {
        return await jobServices.getJobs(filters);
      } catch (error) {
        throw parseApiError(error);
      }
    },

    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes

    placeholderData: (previousData) => previousData,

    retry: 1,
  });
};

/**
 * Get single job
 */
export const useJob = (jobId) => {
  return useQuery({
    queryKey: ['jobs', jobId],

    queryFn: async () => {
      try {
        return await jobServices.getJobById(jobId);
      } catch (error) {
        throw parseApiError(error);
      }
    },

    enabled: !!jobId,

    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes

    retry: 1,
  });
};

/**
 * Get job statistics
 */
export const useJobStats = () => {
  return useQuery({
    queryKey: ['job-stats'],

    queryFn: async () => {
      try {
        return await jobServices.getJobStats();
      } catch (error) {
        throw parseApiError(error);
      }
    },

    staleTime: 2 * 60 * 1000, // 2 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes

    retry: 1,
  });
};